import { defineStore } from 'pinia'

export interface IModalProps {
  modalOpened: boolean
}

export interface IModalState {
  modalState: IModalProps
}

export const useModalStore = defineStore('modal-store', {
  state: () => ({ modalState: new Map() }),
  actions: {
    openModal(uniqueKey: string, payload: IModalProps) {
      const { modalOpened } = payload
      this.modalState.set(uniqueKey, { modalOpened })
    },

    closeModal(uniqueKey: string) {
      this.modalState.delete(uniqueKey)
    },

    isModalOpen(uniqueKey: string) {
      return this.modalState.get(uniqueKey)?.modalOpened || false
    },

    getComponentFromKey(uniqueKey: string) {
      return this.modalState.get(uniqueKey) || { modalOpened: false }
    }
  }
})
